import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const invoices: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_PAYMENTS_API}/get-invoices`),
};

export default invoices;
